export default __webpack_public_path__ + "static/media/stand_7.9240cb87.jpg";